import { useDisciplineStore } from '@entities/customer'
import { useCsRoutes } from '@shared/api'

interface ConfirmDisciplineApiReturn {
  confirmDiscipline: (bookingId: number) => Promise<void>
}

export const useConfirmDisciplineApi = (): ConfirmDisciplineApiReturn => {
  const { $axios } = useNuxtApp()
  const disciplineStore = useDisciplineStore()

  const confirmDiscipline = async (bookingId: number): Promise<void> => {
    const disciplineId = disciplineStore.activeDiscipline?.id
    if (!disciplineId) {
      console.warn('missing disciplineId for classroom/confirm-discipline.hook.ts')
      return
    }

    const url = useCsRoutes('classroom.disciplines.confirm', {
      '[discipline_id]': disciplineId,
    })

    if (!url) {
      console.warn('missing url for classroom/confirm-discipline.hook.ts')
      return
    }

    try {
      await $axios.post(url, { confirm_booking_id: bookingId })
    } catch (err: any) {
      console.error('unable to confirm classroom/confirm-discipline.hook.ts:', err)
    }
  }

  return { confirmDiscipline }
}